import { useAtom } from "jotai";
import { useState, useEffect, useCallback } from "react";
import swrFetcher from "src/utils/swrFetcher";
import swrConfig from "src/config/swrConfig";
import useSWR from "swr";
import { notificationObjectListAtom } from "../notification.atom";
import type { NotificationResponse } from "../notification.type";
import localStorageManager from "src/utils/localStorageManager";

const useNotification = () => {
    const url = "/notifications";
    const [notificationObjectList, setNotificationObjectList] = useAtom(
        notificationObjectListAtom
    );

    const [isLogin, setIsLogin] = useState(false);
    const [isLoginChecked, setIsLoginChecked] = useState(false);

    const checkLoginStatus = useCallback(() => {
        try {
            const token = localStorageManager.getItem("token");
            const loginStatus = token !== null;
            setIsLogin(loginStatus);
            setIsLoginChecked(true);
            return loginStatus;
        } catch (error) {
            console.warn("ログイン状態の確認に失敗しました:", error);
            setIsLogin(false);
            setIsLoginChecked(true);
            return false;
        }
    }, []);

    useEffect(() => {
        checkLoginStatus();

        const handleFocus = () => {
            checkLoginStatus();
        };

        window.addEventListener("focus", handleFocus);

        return () => {
            window.removeEventListener("focus", handleFocus);
        };
    }, [checkLoginStatus]);

    const { error, isLoading } = useSWR<NotificationResponse>(
        isLoginChecked && isLogin ? url : null,
        swrFetcher,
        {
            ...swrConfig.Immutable,
            onSuccess: (res) => {
                setNotificationObjectList(res.notifications);
            },
        }
    );

    return {
        notificationObjectList,
        error,
        isLoading,
        isLogin,
        isLoginChecked,
    };
};

export default useNotification;
